import { render, staticRenderFns } from "./zhishiquanjie.vue?vue&type=template&id=48232d68&scoped=true&"
import script from "./zhishiquanjie.vue?vue&type=script&lang=js&"
export * from "./zhishiquanjie.vue?vue&type=script&lang=js&"
import style0 from "./zhishiquanjie.vue?vue&type=style&index=0&id=48232d68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48232d68",
  null
  
)

export default component.exports